import React, {useEffect, useRef, useState} from "react"
import {useLocal, useRoomSetup, useSolution} from "../AppContext"
import {ButtonClose} from "./Button"
import style from "./SolutionIntroVideo.css"

const VIDEO = {
    poster: "./assets/content/videos/solution-intro.jpg",
    webm: "./assets/content/videos/solution-intro.webm",
    mp4: "./assets/content/videos/solution-intro.mp4",
}
const LOCALSTORAGE_FLAG__SOLUTION_INTRO_VIDEO_SHOWN = 'solution-intro-video-shown'
const SOLUTION_INTRO_VIDEO_SHOWN_DELAY = 2000

export const SolutionIntroVideo = () => {
    const roomSetup = useRoomSetup()
    const solution = useSolution()
    const local = useLocal()
    const solutionIntroVideoInit = useRef(false)
    const [solutionIntroVideoShow, setSolutionIntroVideoShow] = useState(false)

    const isSolutionIntroVideoShown = () => {
        return !!localStorage.getItem(LOCALSTORAGE_FLAG__SOLUTION_INTRO_VIDEO_SHOWN)
    }

    const setSolutionIntroVideoShown = () => {
        localStorage.setItem(LOCALSTORAGE_FLAG__SOLUTION_INTRO_VIDEO_SHOWN, '1');
    }
    
    const setSolutionIntroVideoActive = () => {
        localStorage.setItem(LOCALSTORAGE_FLAG__SOLUTION_INTRO_VIDEO_SHOWN, '2');
    }

    const actionClose = () => {
        setSolutionIntroVideoShown()
        setSolutionIntroVideoShow(false)
    }

    useEffect(() => {
        if(isSolutionIntroVideoShown() || !roomSetup.getId()) {
            return
        }

        if (solution.countSolution() === 0 && solutionIntroVideoInit.current === false) {
            solutionIntroVideoInit.current = true
        }

        if (solution.countSolution() > 0 && solutionIntroVideoInit.current === true) {
            setSolutionIntroVideoActive()
            setTimeout(() => setSolutionIntroVideoShow(true), SOLUTION_INTRO_VIDEO_SHOWN_DELAY)
        }
    }, [roomSetup.getId(), solution.countSolution()])

    if (solutionIntroVideoShow) {
        return <div className={style.container}>
            <div className={style.head}>
                <ButtonClose onClick={actionClose}/>
            </div>
            <div className={style.body}>
                <div className={style.video}>
                    <video loop autoPlay muted controls poster={VIDEO.poster}>
                        <source src={VIDEO.webm} type="video/webm"/>
                        <source src={VIDEO.mp4} type="video/mp4"/>
                        <span>{local.__("Die direkte Video Wiedergabe wird nicht unterstützt. Sie können das Video")}</span>
                        <a href={VIDEO.webm}>{local.__("hier herunterladen")}</a>
                    </video>
                </div>
                <div className={style.title}>{local.__("Ihr Raum, Ihre Gestaltung")}</div>
                <div>{local.__("Verändern Sie unsere Entwürfe wie es Ihnen gefällt, indem Sie Absorber verschieben, verändern, hinzufügen oder entfernen. Nutzen Sie gerne unsere vorgeschlagene Absorbermenge als Orientierung.")}</div>
            </div>
        </div>
    }

    return null
}